import { Box, Button } from "@mui/material";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import useSave from "../../../Hooks/useSave";
import useDatatableAddon from "../../../Hooks/useDatatableAddon";
import useAlert from "../../../Hooks/useAlerts";

export default function Users() {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerId } = useParams();
  const { fetchGraphql, DialogSave } = useSave();
  const [users, setUsers] = useState([]);
  const [addAlert, Feedback] = useAlert();

  const addonOptions = {
    record: {
      userId: `new${users.length + 1}`,
      firstName: "",
      lastName: "",
      phoneNumber: null,
      email: "",
    },
    delete: (tableMeta) => {
      fetchGraphql({
        query: `mutation DeleteUser($userId: ID) {
          deleteUser(userId: $userId)
        }`,
        variables: { userId: tableMeta.rowData[0] },
      });
    },
    send: (tableMeta) => {
      const copyState = [...users];

      const user = copyState.find(
        (item) => item["userId"] === tableMeta.rowData[0]
      );

      fetchGraphql({
        query: `mutation SendUpdateLoginCredentialsEmail($email: String!) {
          sendUpdateLoginCredentialsEmail(email: $email)
        }`,
        variables: { email: user.email },
      }).then((result) => {
        addAlert({
          severity: "success",
          message: "Message sent succesfuly",
        });
        // console.log(result);
      });
    },
    save: (tableMeta) => {
      const copyState = [...users];

      const user = copyState.find(
        (item) => item["userId"] === tableMeta.rowData[0]
      );

      // product = tableMeta.rowData

      const newUser = { ...user };

      delete newUser.userId;

      if (user.userId.includes("new")) {
        // console.log("new");
        return fetchGraphql({
          query: `mutation CreateUser($user: userInput, $customerId: ID) {
            createUser(user: $user, customerId: $customerId)
          }`,
          variables: {
            user: { ...newUser, roleId: 2 },
            customerId: customerId,
          },
        }).then((result) => {
          user.userId = result.data.createUser;

          setUsers(copyState);

          return Promise.resolve("done");
        });
      } else {
        // console.log("old");
        return fetchGraphql({
          query: `mutation UpdateUser($userId: ID, $user: userInput) {
            updateUser(userId: $userId, user: $user)
          }`,
          variables: {
            user: newUser,
            userId: user.userId,
          },
        }).then((result) => {
          return Promise.resolve("done");
        });
      }
    },
    edit: (tableMeta) => {
      return true;
    },
  };

  const [textField, selectField, newRecord, actions, options] =
    useDatatableAddon(users, setUsers, "userId", addonOptions);

  useEffect(() => {
    fetchGraphql({
      query: `query Users($customerId: ID) {
        users(customerId: $customerId) {
          userId
          firstName
          lastName
          phoneNumber
          email
        }
      }`,
      variables: { customerId },
    }).then((result) => setUsers(result.data.users));
  }, [location.pathname === "/users"]);

  const columns = [
    {
      name: "userId",
      options: {
        display: false,
      },
    },
    {
      name: "firstName",
      label: "First Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            firstRow: true,
            width: "200px",
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    {
      name: "lastName",
      label: "Last Name",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "200px",
          };
          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          const options = {
            width: "200px",
          };

          return textField(tableMeta, value, options, updateValue);
        },
      },
    },
    // {
    //   name: "phoneNumber",
    //   label: "Phone Number",
    //   options: {
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       const options = {
    //         width: "200px",
    //         tabNext: true,
    //       };

    //       return textField(tableMeta, value, options, updateValue);
    //     },
    //   },
    // },
    { ...actions },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Feedback />

      <Button
        sx={{ marginLeft: "auto", marginBottom: "20px" }}
        variant="contained"
        onClick={() => {
          // console.log("new user");

          newRecord({
            userId: `new${users.length + 1}`,
            firstName: "",
            lastName: "",
            phoneNumber: null,
            email: "",
          });
        }}
      >
        Add User
      </Button>

      <MUIDataTable
        title={"Users"}
        data={users}
        columns={columns}
        options={options}
      />
    </Box>
  );
}
